import { Config } from '@genial/config';
import { Utils } from '@genial/utils';

import {
  CustomItemTagObject,
  ProductsManagementAdvisorResponse,
  ProductsManagementAvaliableItem,
  ProductsManagementDetailsResponse,
  ProductsManagementFixedIncomeProductsResponse,
} from './types';

const normalizeTags = (item): CustomItemTagObject[] => {
  const tags: CustomItemTagObject[] = [];

  if (item.bloqueadoNivelParceiro) {
    tags.push({ tagName: 'PARCEIRO' });
  }

  if (item.bloqueadoNivelAssessor) {
    tags.push({ tagName: 'ASSESSOR' });
  }

  if (item.bloqueadoNivelCliente) {
    tags.push({ tagName: 'CLIENTE' });
  }
  return tags;
};

export const normalizeName = (name: string): string => {
  if (!name) {
    return '--';
  }

  return name.trim().split(' ')[0].toLowerCase();
};

export const normalizeProductsManagementAvaliableToControlResponse = (
  response: any
): ProductsManagementAvaliableItem => {
  return {
    assetsFundsControl:
      response.ativosFundosControle.map((item) => ({
        productId: item.idProduto || 0,
        fundCnpj: Utils.Mask.Cnpj(item.cnpjFundo) || '--',
        fundName: item.nomeFundo
          ? item.nomeFundo.length > 30
            ? `${item.nomeFundo.substring(0, 30)}...`
            : item.nomeFundo
          : '--',
        managerName: normalizeName(item.nomeGestora),
        fundCategory: item.categoriaFundo || '--',
        blockedPartnerLevel: item.bloqueadoNivelParceiro || 0,
        blockedAdvisorLevel: item.bloqueadoNivelAssessor || 0,
        blockedClientLevel: item.bloqueadoNivelCliente || 0,
        favoritedPartnerLevel: item.favoritadoNivelParceiro || 0,
        favoritedAdvisorLevel: item.favoritadoNivelAssessor || 0,
        favoritedClientLevel: item.favoritadoNivelCliente || 0,
        exclusive: item.exclusivo || false,
        tags: normalizeTags(item),
        managerImage: `${Config.GenialCdnUrl}Fundos/Gestora/${normalizeName(
          item.nomeGestora
        )}_logo_grande.png`,
      })) || [],
    assetsFixedIncomeControl:
      response.ativosRendaFixaControle.map((item) => ({
        managerImage: `${Config.BucketS3AwsUrl}genial-documents/RF/Logo/Emissor/${item.idEmissorImg}.png`,
        productId: item.idEmissorRendaFixa || 0,
        fixedIncomeIssuerName: item.nmEmissorRendaFixa
          ? item.nmEmissorRendaFixa.length > 30
            ? `${item.nmEmissorRendaFixa.substring(0, 30)}...`
            : item.nmEmissorRendaFixa
          : '--',
        blockedPartnerLevel: item.bloqueadoNivelParceiro || false,
        blockedAdvisorLevel: item.bloqueadoNivelAssessor || false,
        blockedClientLevel: item.bloqueadoNivelCliente || false,
        favoritedPartnerLevel: item.favoritadoNivelParceiro || false,
        favoritedAdvisorLevel: item.favoritadoNivelAssessor || false,
        favoritedClientLevel: item.favoritadoNivelCliente || false,
        platformFilterProductId: item.idProdutoFiltroPlataforma || false,
        tags: normalizeTags(item),
      })) || [],
    messageFunds: response.mensagemFundos || '--',
    messageRF: response.mensagemRF || '--',
  };
};

export const normalizeProductManagementDetailsResponse = (
  response: any
): ProductsManagementDetailsResponse[] => {
  return response.map((item) => ({
    destinationProductFilterId: item.idProdutoFiltroTPDestino || null,
    destinationProductFilterName: item.nomeProdutoFiltroTPDestino || '--',
    informationProductFilterId: item.idProdutoFiltroInformacao || null,
    branchId: item.idFilial || null,
    branchName: item.nomeFilial || '--',
    advisorId: item.idAssessor || null,
    advisorName: item.nomeAssessor || '--',
    accountId: item.idConta || null,
    clientId: item.idCliente || null,
    clientName: item.nomeCliente || '--',
    clientPersonType: item.tipoPessoaCliente || null,
    clientDocument: item.documentoCliente || null,
    clientAdvisorId: item.idAssessorCliente || null,
    clientAdvisorName: item.nomeAssessorCliente || '--',
    platform: item.plataforma || '--',
    originId: item.idOrigem || null,
    originName: item.nomeOrigem || '--',
    canDelete: item.podeExcluir || null,
    productsList:
      item.listaProdutos?.map((product) => ({
        informationProductFilterId: product.idProdutoFiltroInformacao || null,
        productName: product.nomeProduto || '--',
        productDescription: product.descricaoProduto || '--',
        canDelete: product.podeExcluir || false,
      })) || undefined,
  }));
};

export const normalizeProductManagementAdvisorResponse = (
  response: any
): ProductsManagementAdvisorResponse[] => {
  return response.splice(0, 5).map((item) => ({
    resourceId: item.idRecurso || 0,
    partnerId: item.idParceiro || 0,
    advisorIntranetId: item.idAssessorIntranet || 0,
    resourceFirstName: item.primeiroNomeRecurso || '--',
    resourceLastName: item.ultimoNomeRecurso || '--',
    document: item.cpf || '--',
    contactEmail: item.emailContato || '--',
    partnerName: item.nomeParceiro || '--',
    isMasterGroup: item.masterGrupo || false,
    isMasterOffice: item.masterEscritorio || false,
    isActive: item.ativo || false,
  }));
};

export const normalizeProductManagementFixedIncomeProductsResponse = (
  response: any
): ProductsManagementFixedIncomeProductsResponse[] => {
  return response.map((item) => ({
    productId: item.idProduto,
    ProductName: item.nmProduto,
  }));
};
